import { z } from 'zod';

export enum PersonalizationTypes {
	VIEW = 'view',
	GENRE = 'genre',
	BUY = 'buy',
	GALLERY = 'gallery'
}

export const PersonalizationGenreEventValidator = z.object({
	type: z.literal(PersonalizationTypes.GENRE),
	data: z.array(z.string())
});

export const PersonalizationGalleryEventValidator = z.object({
	type: z.literal(PersonalizationTypes.GALLERY),
	data: z.object({
		type: z.string(),
		data: z.string().nullish()
	})
});

export const PersonalizationViewEventValidator = z.object({
	type: z.literal(PersonalizationTypes.VIEW),
	data: z.object({
		event: z.string(),
		genres: z.array(z.string())
	})
});

export const PersonalizationBuyEventValidator = z.object({
	type: z.literal(PersonalizationTypes.BUY),
	data: z.object({
		event: z.string(),
		genres: z.array(z.string())
	})
});

export const PersonalizationEntryValidator = z.union([
	PersonalizationGenreEventValidator,
	PersonalizationGalleryEventValidator,
	PersonalizationViewEventValidator,
	PersonalizationBuyEventValidator
]);

export const PersonalizationDataValidator = z.object({
	events: z.array(PersonalizationEntryValidator)
});

export type PersonalizationEntry = z.infer<typeof PersonalizationEntryValidator>;
export type PersonalizationData = z.infer<typeof PersonalizationDataValidator>;
